import DOMPurify from "dompurify";

export function sanitizeHTML(dirty) {
  return DOMPurify.sanitize(dirty);
}
